
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DetailsPageUploader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UploaderConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestAccessKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bucket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requestEndpoint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signatureEndpoint"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"keyPrefix"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signatureVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"region"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":171}};
    doc.loc.source = {"body":"fragment DetailsPageUploader on UploaderConfig {\n    requestAccessKey\n    bucket\n    requestEndpoint\n    signatureEndpoint\n    keyPrefix\n    signatureVersion\n    region\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
